// returns new list with item from startIndex moved to endIndex
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

// returns new list rearranged in order list
// e.g. reorderByIndex( [a,b,c], [0,2,1]) => [a,c,b]
export const reorderByIndex = (inputList, orderList) => {
  const result = [];
  orderList.forEach(item => result.push(inputList[item]));
  return result;
};

// reverses the effect of reorderByIndex
// returns original list that was passed into reorderByIndex
export const reverseReorderByIndex = (inputList, orderList) => {
  const result = [];
  orderList.forEach((item, index) => {
    result[item] = inputList[index];
  });
  return result;
};

export default reorder;
